<template>
  <div class="bottomright" v-loading.body="loading">
    <div class="bottomtitle" style="margin-top: 30px;">
      <div class="titletext" style="margin-left: 30px;">{{$t('lang.research_dynamic')}}</div>
      <div class="titletextfu">{{$t('lang.research_dynamic_zh')}}</div>
    </div>
    <div
      @click="toyanjiujinzhanxiangqingye(item.id,item.type)"
      v-for="(item,index) in dongtaicard"
      :key="index"
    >
      <div class="bottomtextlist" v-if="index<=4">
        <div class="rightline" :style="{'background':type_color(item.type)}"></div>
        <div class="righttext">
          <div style=" display: flex;">
            <span class="righttext_div_span">
              {{item.title}}
              <!-- <span v-show="isdiandiandian">...</span> -->
            </span>
            <span style=" margin-top: 7px;">{{item.category_name}}</span>
            <span
              style="    margin-left: 5px; font-size: 13px; color: #888888;"
              v-if="!item.category_name"
            >{{$t('lang.work')}}</span>
          </div>
          <div class="righttime">
            <span>{{item.publish_date}}</span>
            <!-- <span >{{item.url}}</span> -->
          </div>
        </div>
      </div>
      <div v-show="false">{{all_app_color_comp}}</div>
    </div>
    <!-- v-if="dongtaicard.length>5" -->
    <div
      class="lookmore"
     
      :style="{color:all_app_color}"
      @click="toresearchprogress"
    >{{$t('lang.more')}}>></div>
  </div>
</template>

<script>
import * as serviceApi from "./api/dongtaicard";
// let that = this;
export default {
  name: "dongtaicard",
  data() {
    return {
      loading: true,
      dongtaicard: "",
      all_app_color: "#3b9dce",
      type_color_list: ["#FF851B", "#0074D9", "#F012BE", "#2ECC40"],
      home_nav_list_is_hide_on_topath: {
        //导航菜单隐藏的情况下，点击首页更多，判断是否跳转
        have_value: false,
        ktzjs: false,
        yjfx: false,
        cgzs: false,
        dt: false,
        kysb: false,
        cygl: false,
        principalIntroduce: false,
        fzrjs: false
      }
      // isdiandiandian: false
    };
  },
  computed: {
    all_app_color_comp() {
      if (this.$store.state.all_app_color) {
        this.all_app_color = this.$store.state.all_app_color; //将本地的全局配色，赋值给 this.all_app_color
      }
      return "";
    },
    type_color() {
      return function(type) {
        if (type == "LWLB00000") {
          return "#0074D9";
        } else if (type == "RYLB00000") {
          return "#FF851B";
        } else if (type == "ZLLB00000") {
          return "#2ECC40";
        } else {
          return this.all_app_color;
        }
      };
    }
  },
  created() {
    if (this.$store.state.all_app_color) {
      this.all_app_color = this.$store.state.all_app_color;
    } else {
      this.all_app_color = localStorage.getItem("all_app_color"); //将本地的全局配色，赋值给 this.all_app_color
    }
    // this.getData();
    // if (this.dada) {
    //   return;
    // } else {
    //   this.clickgettivenewDataList();
    // }
    this.newtivedatalistiskong(); //获取最新五条数据
    this.home_nav_list_is_hide_on_topath = this.$store.state.home_nav_list_is_hide_on_topath;
  },
  // filters: {
  //   //限制字数
  //   jiequzfc(val) {
  //     let maxChars = 15; //最多字符数
  //     let vall =val;
  //     // let reg = /[A-Za-z0-9]*/;
  //     // let isis = values.match(reg);
  //     // this.param.bottomyzm = isis[0];
  //     if (val.length > maxChars) {
  //       // alert("验证码为四位数，自动截取前四位数!");
  //       vall = val.substring(0, maxChars);
  //       that.isdiandiandian = true;
  //       // return new Error("验证码不能为空)");
  //       // callback(new Error("自动截取前4个字符！"));
  //     }
  //     return vall;
  //   }
  // },

  methods: {
    // click_new_href(id) {
    //   this.$router.push({
    //     path: "/researchProgressDetails",
    //     query: {
    //       id: id,
    //       index: this.istypeactive
    //     }
    //   });
    // },
    // toresearchprogressxiangqing(id){
    //   this.$router.push({path:'/researchprogress',query: {id:id}});
    // },
    toyanjiujinzhanxiangqingye(id, type) {
      // if (this.home_nav_list_is_hide_on_topath.cgzs) {
        this.$store.commit("change_home_more_click", true);

        let index = "";

        if (type == "RYLB00000") {
          index = 0;
        } else if (type == "LWLB00000") {
          index = 1;
        } else if (type == "ZZLB00000") {
          index = 2;
        } else if (type == "ZLLB00000") {
          index = 3;
        }

        if (this.$router.currentRoute.path == "/researchProgressDetails") {
          this.$emit("func", {
            id: id,
            index: index
          });
        } else {
          // this.$router.push({
          //   path: "/researchprogress",
          //   query: { id: id, data: data, type: type }
          // });

          this.$router.push({
            path: "/researchProgressDetails",
            query: {
              id: id,
              index: index
            }
          });
        }
      // }
    },

    toresearchprogress() {
      // if (this.home_nav_list_is_hide_on_topath.cgzs) {
        this.$store.commit("change_home_more_click", true);
        this.$router.push({ path: "/researchprogress" });
      // }
    },
    newtivedatalistiskong() {
      //根据vuex中的数据来判断是否要再次请求新的五条数据
      let aa = this.$store.state.newtivelist; //     可以后期添加啥事件用来清空这个，然后再次请求新的五条动态信息
      if (!aa) {
        this.clickgettivenewDataList();
      } else {
        this.dongtaicard = aa;
        this.loading = false;
      }
    },
    clickgettivenewDataList() {
      let that = this;
      serviceApi.gettivenewDataList({}).then(body => {
        that.dongtaicard = body.data;
        that.$store.commit("newtivedatalist", body.data);
        this.loading = false;
      });
      // alert("1212");
    }
  }
};
</script>

<style scoped>
.righttext_div_span {
  font-size: 16px;
  font-weight: 600;
  width: 160px;
  vertical-align: top;
  height: 32px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 7px;
}
.righttext_div_span:hover {
  color: var(--color);
}
.lookmore {
  /* color: #3b9dce; */
  margin-left: 50px;
  display: inline-block;
  font-size: 14px;
  cursor: pointer;
}
.righttext {
  width: 210px;
  margin: 0 10px 0 20px;
  cursor: pointer;
}
.righttime {
  display: flex;
}

.righttime {
  font-size: 12px;
  /* margin-top: 10px; */
  display: flex;
  justify-content: space-between;
}
.righttext span:nth-of-type(2) {
  margin-left: 5px;
  font-size: 13px;
  color: #888888;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rightline {
  width: 3px;
  margin: 5px 0;
  margin-left: 30px;
  /* background: #c7cfd1; */
}
.bottomtextlist {
  display: flex;
  margin-bottom: 20px;
  height: 55px;
}
.bottom {
  display: flex;
}
.bottomright {
  margin-left: auto;
  margin-bottom: 30px;
  width: 300px;
  height: 500px;
  border: 1px solid #f3f3f3;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.21);
}
.bottomtitle {
  display: flex;
  margin-bottom: 30px;
}
.titletextfu {
  color: #cccccc;
  font-size: 20px;
  margin-left: 30px;
}
.titletext {
  font-size: 22px;
  font-weight: 600;
}
.top {
  margin: 30px 0;
}
.container {
  padding: 0px;
  background: #ffffff;
  border: none;
  border-radius: 0px;
}
.page {
  width: 1200px;
  margin: 0 auto;
}
/*在992 和1199 像素之间的屏幕里，中等屏幕，分辨率低的PC*/
@media (min-width: 992px) and (max-width: 1199px) {
  .page,
  .bottom {
    width: 992px;
  }
  .bottomcontain {
    width: 700px;
  }
  .tiaojian,
  .bottomright {
    width: 300px;
  }
}
/*在768 和991 像素之间的屏幕里，小屏幕，主要是PAD*/
@media (min-width: 768px) and (max-width: 991px) {
}
/*在480 和767 像素之间的屏幕里，超小屏幕，主要是手机*/
@media (min-width: 480px) and (max-width: 767px) {
}
/*在小于480px的屏幕里，微小屏幕，更低分辨率的手机*/
@media (max-width: 479px) {
}
</style>



// WEBPACK FOOTER //
// src/components/page/dongtaicard/dongtaicard.vue